/**
 * OA Header Popups — Cart drawer, Favorieten, Account, Zoeken
 * Open via [data-oa-popup="cart|favorites|account|search"]
 * Sluiten: [data-oa-pop-close], klik op backdrop, of ESC.
 * Door Online Actief — online-actief.nl
 */
(function () {
  'use strict';

  var CFG = window.OAHeaderPopupsConfig || {};
  var ROUTES = CFG.routes || {};
  var SETTINGS = CFG.settings || {};
  var WISHLIST_KEY = 'oaWishlist';

  /* ════════════ Helpers ════════════ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function formatMoney(cents) {
    var amt = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + amt;
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  /* ════════════ Open/close ════════════ */
  var lastFocus = null;
  function openPop(name) {
    var el = $('#oa-pop-' + name);
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('oa-pop-locked');
    if (name === 'cart') refreshCart();
    if (name === 'favorites') renderFavorites();
    if (name === 'search') {
      var input = $('[data-oa-search-input]', el);
      setTimeout(function () { input && input.focus(); }, 50);
    }
  }
  function closePop(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    if (!$$('.oa-pop[aria-hidden="false"]').length) {
      document.body.classList.remove('oa-pop-locked');
    }
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) { }
  }
  function closeAll() { $$('.oa-pop[aria-hidden="false"]').forEach(closePop); }

  /* ════════════ Triggers ════════════ */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-oa-popup]');
    if (trigger) {
      var name = trigger.getAttribute('data-oa-popup');
      if (name && $('#oa-pop-' + name)) {
        e.preventDefault();
        openPop(name);
        return;
      }
    }
    var closer = e.target.closest('[data-oa-pop-close]');
    if (closer) {
      var pop = closer.closest('.oa-pop');
      if (pop) { e.preventDefault(); closePop(pop); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
  /* Extern openen van het winkelwagen-drawer (bv. sticky add-to-cart op de productpagina) */
  document.addEventListener('oa:open-cart', function () { openPop('cart'); });

  /* ════════════ Auto-bind theme icons ════════════ */
  if (SETTINGS.autoBindThemeCart) {
    var BIND = [
      { popup: 'cart', enabled: SETTINGS.enableCart, sels: ['.navlink--cart', 'a[href="/cart"]', 'a[href$="/cart"]', '.header__icon--cart a', '.site-header__cart', '.cart-icon-bubble', '.header-cart-btn', 'a.cart-link', '[data-cart-toggle]', '[data-drawer-toggle="drawer-cart"]', '.js-drawer-open-right', '.Header__Icon--cart'] },
      { popup: 'account', enabled: SETTINGS.enableAccount, sels: ['a[href="/account"]', 'a[href$="/account"]', '.header__icon--account a', 'a.navlink[aria-label="Account"]'] },
      { popup: 'search', enabled: SETTINGS.enableSearch, sels: ['a[href="/search"]', 'a[href$="/search"]', '[data-popdown-toggle="search-popdown"]', '.header__icon--search a', 'a.navlink[aria-label="Zoeken"]'] },
      { popup: 'favorites', enabled: SETTINGS.enableFavorites, sels: ['a[href="/pages/wishlist"]', 'a[href$="/pages/wishlist"]', '.oa-wishlist-header-icon-desktop', '.oa-wishlist-header-icon-mobile', 'a.navlink[aria-label="Favorieten"]'] }
    ];
    document.addEventListener('click', function (e) {
      for (var b = 0; b < BIND.length; b++) {
        var it = BIND[b];
        if (!it.enabled) continue;
        for (var i = 0; i < it.sels.length; i++) {
          var hit = e.target.closest(it.sels[i]);
          if (hit && !hit.hasAttribute('data-oa-popup')) {
            e.preventDefault();
            openPop(it.popup);
            return;
          }
        }
      }
    }, true);
  }

  /* ════════════════════════════════════════════════
     CART DRAWER
     ════════════════════════════════════════════════ */
  var cartState = null;

  function fetchCart() {
    return fetch(ROUTES.cartGet || '/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function changeCart(line, qty) {
    return fetch(ROUTES.cartChange || '/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function bumpHeaderCartCount(prevCount, nextCount) {
    /* Update onze eigen [data-oa-cart-count] badges (tekst + zichtbaarheid) */
    var oaBadges = document.querySelectorAll('[data-oa-cart-count]');
    oaBadges.forEach(function (el) {
      el.textContent = nextCount > 99 ? '99+' : String(nextCount);
      el.classList.toggle('is-hidden', nextCount === 0);
    });
    /* Bump animatie op alle gangbare cart-count badge selectors */
    var els = document.querySelectorAll('[data-header-cart-count], [data-oa-cart-count], .cart-count, .header__cart-count, [data-cart-count]');
    if (!els.length) return;
    els.forEach(function (el) {
      el.classList.remove('oa-cart-just-bumped');
      void el.offsetWidth; /* force reflow */
      if (nextCount > 0 && prevCount >= 0 && prevCount !== nextCount) el.classList.add('oa-cart-just-bumped');
    });
  }

  function dispatchCartChange(cart) {
    /* Zodat theme.js (Totals class) het cart-cijfer in de header bijwerkt */
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
  }

  function addToCart(variantId, qty) {
    return fetch(ROUTES.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  /* Cart upsell — op basis van wat er in de wagen ligt. Per product gekoppeld via
     metafield custom.winkelwagen_upsells; server-side gerenderd via de sectie
     oa-cart-upsell (Section Rendering API), zodat het live meebeweegt met de wagen. */
  function renderUpsell(cart) {
    var pop = $('#oa-pop-cart'); if (!pop) return;
    var wrap = $('[data-oa-cart-upsell]', pop); if (!wrap) return;
    var list = $('[data-oa-cart-upsell-items]', pop); if (!list) return;
    if (SETTINGS.upsellEnable === false || !cart || cart.item_count === 0) { wrap.hidden = true; list.innerHTML = ''; return; }
    var base = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    fetch(base + '?section_id=oa-cart-upsell', { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('.oa-pop-upsell__item', doc);
        if (!items.length) { wrap.hidden = true; list.innerHTML = ''; return; }
        list.innerHTML = items.map(function (li) { return li.outerHTML; }).join('');
        wrap.hidden = false;
      })
      .catch(function () { wrap.hidden = true; list.innerHTML = ''; });
  }

  function renderCart(cart) {
    var prevCount = cartState ? cartState.item_count : -1;
    cartState = cart;
    var pop = $('#oa-pop-cart'); if (!pop) return;
    var itemsEl = $('[data-oa-cart-items]', pop);
    var subtotalEl = $('[data-oa-cart-subtotal]', pop);
    var countLabel = $('[data-oa-cart-count-label]', pop);
    var checkoutBtn = $('[data-oa-cart-checkout]', pop);

    pop.classList.toggle('is-empty', cart.item_count === 0);

    /* Header cijfer + bump-animatie */
    dispatchCartChange(cart);
    bumpHeaderCartCount(prevCount, cart.item_count);

    if (countLabel) {
      countLabel.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'artikel' : 'artikelen');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Korting — alleen tonen wanneer er korting is. cart.total_price is reeds ná korting,
       dus het bedrag dat de klant betaalt telt mee voor de gratis-verzendingsdrempel. */
    var discWrap = $('[data-oa-cart-discount]', pop);
    if (discWrap) {
      if (cart.total_discount && cart.total_discount > 0) {
        var amtEl = $('[data-oa-cart-discount-amount]', discWrap);
        var lblEl = $('[data-oa-cart-discount-label]', discWrap);
        if (amtEl) amtEl.textContent = '−' + formatMoney(cart.total_discount);
        if (lblEl) {
          var titles = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).filter(Boolean);
          lblEl.textContent = titles.length ? ('Korting · ' + titles.join(', ')) : 'Korting';
        }
        discWrap.hidden = false;
      } else {
        discWrap.hidden = true;
      }
    }

    if (checkoutBtn) checkoutBtn.classList.toggle('is-disabled', cart.item_count === 0);

    if (itemsEl) {
      if (cart.item_count === 0) { itemsEl.innerHTML = ''; }
      else {
        itemsEl.innerHTML = cart.items.map(function (item, i) {
          var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
          var imgUrl = img ? img.replace(/(\.[^.\/]+)(\?.*)?$/, '_120x144_crop_center$1$2') : '';
          var variant = '';
          if (item.options_with_values && item.options_with_values.length) {
            variant = item.options_with_values.filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return escapeHtml(o.value); }).join(' · ');
          }
          var compareHtml = (item.original_price && item.original_price > item.final_price)
            ? '<span class="oa-pop-cart__item-price-compare">' + formatMoney(item.original_price * item.quantity) + '</span>' : '';
          return '<li class="oa-pop-cart__item" data-line="' + (i + 1) + '">' +
            '<a class="oa-pop-cart__item-img" href="' + escapeHtml(item.url) + '">' +
              (imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="oa-pop-cart__item-info">' +
              '<a class="oa-pop-cart__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
              (variant ? '<span class="oa-pop-cart__item-variant">' + variant + '</span>' : '') +
              '<div class="oa-pop-cart__item-qty" data-oa-cart-qty>' +
                '<button type="button" data-oa-cart-dec aria-label="Verlagen">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-oa-cart-inc aria-label="Verhogen">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="oa-pop-cart__item-side">' +
              '<span class="oa-pop-cart__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              compareHtml +
              '<button type="button" class="oa-pop-cart__item-remove" data-oa-cart-remove>Verwijder</button>' +
            '</div>' +
          '</li>';
        }).join('');
      }
    }

    /* Free shipping bar */
    var ship = $('[data-oa-cart-ship]', pop);
    if (ship && SETTINGS.freeShippingActive) {
      var threshold = (SETTINGS.freeShippingThreshold || 0) * 100;
      var pct = threshold ? Math.min(100, Math.round((cart.total_price / threshold) * 100)) : 100;
      var fill = $('[data-oa-cart-ship-fill]', ship);
      var text = $('[data-oa-cart-ship-text]', ship);
      if (fill) fill.style.width = pct + '%';
      ship.classList.toggle('is-free', pct >= 100);
      if (text) {
        if (pct >= 100) text.innerHTML = '<strong>Gefeliciteerd —</strong> je krijgt gratis verzending';
        else {
          var remaining = threshold - cart.total_price;
          text.innerHTML = 'Nog <strong>' + formatMoney(remaining) + '</strong> voor gratis verzending';
        }
      }
    }

    renderUpsell(cart);
  }

  function refreshCart() { fetchCart().then(renderCart).catch(function () { }); }

  /* Cart event delegation */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.oa-pop-cart__item'); if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    if (!cartState || !cartState.items[line - 1]) return;
    var cur = cartState.items[line - 1];

    if (e.target.closest('[data-oa-cart-inc]')) {
      e.preventDefault();
      changeCart(line, cur.quantity + 1).then(renderCart);
    } else if (e.target.closest('[data-oa-cart-dec]')) {
      e.preventDefault();
      changeCart(line, Math.max(0, cur.quantity - 1)).then(renderCart);
    } else if (e.target.closest('[data-oa-cart-remove]')) {
      e.preventDefault();
      changeCart(line, 0).then(renderCart);
    }
  });

  /* Upsell toevoegen — direct in de drawer, popup blijft open */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oa-upsell-add]'); if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id'); if (!vid || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    addToCart(vid, 1)
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  /* Onderschep cart-add formulieren zodat de drawer opent na toevoegen */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.oaCartIgnore) return;
    e.preventDefault();
    var fd = new FormData(form);
    fetch(ROUTES.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function () {
      refreshCart();
      openPop('cart');
    }).catch(function () { form.dataset.oaCartIgnore = '1'; form.submit(); });
  }, true);

  /* ════════════════════════════════════════════════
     FAVORIETEN
     ════════════════════════════════════════════════ */
  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function setFavorites(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function renderFavorites() {
    var pop = $('#oa-pop-favorites'); if (!pop) return;
    var list = getFavorites();
    var itemsEl = $('[data-oa-fav-items]', pop);
    var countLabel = $('[data-oa-fav-count-label]', pop);
    pop.classList.toggle('is-empty', list.length === 0);
    if (countLabel) countLabel.textContent = list.length + ' ' + (list.length === 1 ? 'product' : 'producten');
    if (!itemsEl) return;
    if (!list.length) { itemsEl.innerHTML = ''; return; }
    itemsEl.innerHTML = list.map(function (item) {
      var img = item.image || '';
      var price = item.price ? '<span class="oa-pop-fav__item-price">' + escapeHtml(item.price) + '</span>' : '';
      return '<li class="oa-pop-fav__item" data-handle="' + escapeHtml(item.handle) + '">' +
        '<a class="oa-pop-fav__item-img" href="' + escapeHtml(item.url || ('/products/' + item.handle)) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.title || '') + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="oa-pop-fav__item-info">' +
          '<a class="oa-pop-fav__item-title" href="' + escapeHtml(item.url || ('/products/' + item.handle)) + '">' + escapeHtml(item.title || item.handle) + '</a>' +
          price +
        '</div>' +
        '<div class="oa-pop-fav__item-actions">' +
          '<a class="oa-pop-fav__item-add" href="' + escapeHtml(item.url || ('/products/' + item.handle)) + '">Bekijk</a>' +
          '<button type="button" class="oa-pop-fav__item-remove" data-oa-fav-remove>Verwijder</button>' +
        '</div>' +
      '</li>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-oa-fav-remove]'); if (!rm) return;
    var item = rm.closest('.oa-pop-fav__item'); if (!item) return;
    var handle = item.getAttribute('data-handle');
    setFavorites(getFavorites().filter(function (x) { return x.handle !== handle; }));
    renderFavorites();
  });
  /* Re-render als de wishlist verandert — andere tab (storage) of zelfde tab (custom event) */
  window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) renderFavorites(); });
  window.addEventListener('oa-wishlist:changed', function () { renderFavorites(); });

  /* ════════════════════════════════════════════════
     ACCOUNT — view toggle (login ⇄ recover)
     ════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-oa-acc-toggle]'); if (!tog) return;
    e.preventDefault();
    var view = tog.getAttribute('data-oa-acc-toggle');
    $$('[data-oa-acc-form-wrap]').forEach(function (w) {
      w.hidden = w.getAttribute('data-oa-acc-view') !== view;
    });
  });

  /* Open recover-view automatisch als hash #recover meegegeven is */
  if (location.hash === '#recover') {
    var rec = $('[data-oa-acc-form-wrap][data-oa-acc-view="recover"]');
    var log = $('[data-oa-acc-form-wrap][data-oa-acc-view="login"]');
    if (rec && log) { rec.hidden = false; log.hidden = true; }
  }

  /* ════════════════════════════════════════════════
     ZOEKEN — predictive
     ════════════════════════════════════════════════ */
  var searchPop = $('#oa-pop-search');
  if (searchPop) {
    var input = $('[data-oa-search-input]', searchPop);
    var resultsEl = $('[data-oa-search-results]', searchPop);
    var quickEl = $('[data-oa-search-quick]', searchPop);

    var doSearch = debounce(function () {
      var q = (input.value || '').trim();
      if (!q) {
        searchPop.classList.remove('has-query');
        if (resultsEl) resultsEl.innerHTML = '';
        return;
      }
      searchPop.classList.add('has-query');
      var url = (ROUTES.suggest || '/search/suggest.json') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page' +
        '&resources[limit]=6';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var R = (data.resources && data.resources.results) || {};
          var html = '';
          var products = R.products || [];
          if (products.length) {
            html += '<div class="oa-pop-search__result-group">' +
              '<h3 class="oa-pop-search__group-title">Producten</h3>' +
              products.map(function (p) {
                var img = (p.image || (p.featured_image && p.featured_image.url) || '');
                var price = p.price ? formatMoney(parseFloat(String(p.price).replace(/[^\d.]/g, '')) * 100) : '';
                return '<a class="oa-pop-search__result" href="' + escapeHtml(p.url) + '">' +
                  '<div class="oa-pop-search__result-img">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</div>' +
                  '<div class="oa-pop-search__result-info">' +
                    '<span class="oa-pop-search__result-title">' + escapeHtml(p.title) + '</span>' +
                    (price ? '<span class="oa-pop-search__result-price">' + price + '</span>' : '') +
                  '</div>' +
                  '<svg class="oa-pop-search__result-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
                '</a>';
              }).join('') + '</div>';
          }
          var collections = R.collections || [];
          if (collections.length) {
            html += '<div class="oa-pop-search__result-group">' +
              '<h3 class="oa-pop-search__group-title">Collecties</h3>' +
              collections.map(function (c) {
                return '<a class="oa-pop-search__result" href="' + escapeHtml(c.url) + '">' +
                  '<div class="oa-pop-search__result-info"><span class="oa-pop-search__result-title">' + escapeHtml(c.title) + '</span></div>' +
                  '<svg class="oa-pop-search__result-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
                '</a>';
              }).join('') + '</div>';
          }
          if (!products.length && !collections.length) {
            html = '<div class="oa-pop-search__noresults">Geen resultaten voor "' + escapeHtml(q) + '". Druk op enter om uitgebreid te zoeken.</div>';
          }
          html += '<a href="' + (ROUTES.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product" class="oa-pop-search__viewall">Toon alle resultaten voor "' + escapeHtml(q) + '"</a>';
          if (resultsEl) resultsEl.innerHTML = html;
        })
        .catch(function () { });
    }, 220);

    if (input) {
      input.addEventListener('input', doSearch);
      input.addEventListener('focus', function () { if (input.value) doSearch(); });
    }
  }

  /* ════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════ */
  if (SETTINGS.enableCart) refreshCart();
  if (SETTINGS.enableFavorites) renderFavorites();
})();
